import { BodyText, alpha, borderAlpha } from "../../components/mobile/primitives";

export function Principle({ number, title, body }) {
  return (
    <div
      className="rounded-3xl p-6 sm:p-7"
      style={{
        background: "rgba(254,253,251,0.55)",
        border: "1px solid rgba(255,255,255,0.40)",
        backdropFilter: "blur(24px) saturate(150%)",
        boxShadow:
          "0 4px 16px -4px rgba(0,0,0,0.04), 0 2px 4px -2px rgba(0,0,0,0.02), inset 0 1px 0 rgba(255,255,255,0.7)",
      }}
    >
      <p
        className="mb-3"
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "var(--color-kin-muted)",
          fontFamily: "'Manrope', system-ui",
        }}
      >
        {number}
      </p>
      <p
        className="mb-3"
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: "var(--color-kin-black)",
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          lineHeight: 1.15,
        }}
      >
        {title}
      </p>
      <p
        style={{
          fontSize: 14,
          color: "var(--color-kin-muted)",
          lineHeight: 1.7,
          fontFamily: "'Manrope', system-ui",
          fontWeight: 400,
        }}
      >
        {body}
      </p>
    </div>
  );
}

export function OnboardingFooter({ label = "Continue", enabled = true, showSkip = true }) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        padding: "8px 16px 12px",
        display: "flex",
        alignItems: "center",
        gap: 8,
        background: "linear-gradient(to top, rgba(248,245,238,1) 60%, rgba(248,245,238,0))",
        zIndex: 5,
      }}
    >
      <div
        style={{
          flex: 1,
          background: enabled ? "var(--color-kin-lavender)" : "rgba(0,0,0,0.08)",
          borderRadius: 14,
          padding: "12px 0",
          textAlign: "center",
          boxShadow: enabled ? "0 4px 16px -4px rgba(165,144,255,0.4)" : "none",
          transition: "all 0.2s ease",
        }}
      >
        <BodyText size={11} color={enabled ? "#fff" : "var(--color-kin-muted)"} weight={700}>
          {label}
        </BodyText>
      </div>
      {showSkip && (
        <BodyText
          size={9}
          color="var(--color-kin-muted)"
          weight={600}
          style={{ flexShrink: 0, padding: "0 4px" }}
        >
          Skip
        </BodyText>
      )}
    </div>
  );
}

export function JourneyProgress({ current, total = 4 }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", gap: 6, marginBottom: 2 }}>
      {Array.from({ length: total }).map((_, i) => {
        const isDone = i < current;
        const isCurrent = i === current - 1;
        return (
          <div
            key={i}
            style={{
              width: isCurrent ? 18 : 6,
              height: 6,
              borderRadius: 3,
              background: isDone ? "var(--color-kin-green-soft)" : "rgba(0,0,0,0.10)",
            }}
          />
        );
      })}
    </div>
  );
}

export function DataNeedIcon({ type, accent }) {
  const icons = {
    wearable: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke={accent}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="6" y="2" width="12" height="20" rx="4" />
        <path d="M12 10v4" />
        <path d="M10 12h4" />
      </svg>
    ),
    sleep: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke={accent}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
    ),
    lab: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke={accent}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9 3v7l-4 8a2 2 0 0 0 1.8 3h10.4a2 2 0 0 0 1.8-3l-4-8V3" />
        <path d="M8 3h8" />
      </svg>
    ),
    meals: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke={accent}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
        <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
        <line x1="6" y1="1" x2="6" y2="4" />
        <line x1="10" y1="1" x2="10" y2="4" />
        <line x1="14" y1="1" x2="14" y2="4" />
      </svg>
    ),
    workout: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke={accent}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
  };
  return (
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: 7,
        background: alpha(accent, "14"),
        border: borderAlpha(accent, "28"),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
      title={type}
    >
      {icons[type] || null}
    </div>
  );
}
